<ng-template #addComment>
  <div class="d-flex p-5 rounded flex-column justify-content-center align-items-center">
    <p class="mb-3" style="font-weight: bold; color: var(--primary)">
      <!-- <i class="fab fa-forumbee"></i>  -->
      Add comment To Forum
    </p>
    <div class="d-flex flex-column w-100 justify-content-center mb-2" style="top: 100%; background-color: var(--white)">
      <textarea
        rows="3"
        type="text"
        class="form-control mb-2"
        placeholder="Your Comment"
        [(ngModel)]="repliesHolder"
      ></textarea>
      <button class="btn btn-sm btn-outline-primary" (click)="addPostToForum(forum)">
        <i class="fa fa-comments"></i> comment
      </button>
    </div>
  </div>
</ng-template>

<div
  class="d-flex flex-column justify-content-center align-items-center forum"
  [class.left-sz]="!isOnSmallerDevice && modifyWhenOnSmallDevice"
  [class.position-absolute]="!isOnSmallerDevice && modifyWhenOnSmallDevice"
  *ngIf="(isUserAnAdmin || forums?.length) && showCarousel"
  style="right: calc(100%); top: 0; width: 20em;"
>

  <div class="w-100 d-flex flex-column mr-3 p-2 forum-swiper" style="min-height: 16rem">
    <app-my-carousel-swiper [config]="forumCarouselConfig">
      <div
        *ngFor="let forum of forums; index as i"
        class="w-100 mb-5 forum-entry swiper-slide"
        style="position: static !important"
      >
        <div class="card">
          <div class="w-100 card-body text-start" (click)="openForum(forum)">
            <i class="fa-solid fa-up-right-from-square"></i>
            <span class="card-body forum-title">{{ forum.title }} ({{ forum.replies?.length }})</span>
          </div>

          <div class="position-relative" style="height: auto">
            <div class="w-100 d-flex justify-content-end position-relative" style="right: 0.3rem">
              <button class="t-btn" (click)="$event.stopPropagation(); toggleLikeForum(forum)">
                <i
                  class="ml-2 fa-heart"
                  [class.fa-solid]="forum?.isLiked"
                  [class.fa-regular]="!forum?.isLiked"
                ></i>
              </button>
            </div>
          </div>

          <div style="min-height: 16rem; overflow-y: scroll;">
            <div class="w-100 card" *ngFor="let reply of forum.replies">
              <div class="w-100 d-flex justify-content-center card-body">
                <div [innerHtml]="reply.message" style="width: 100%; text-align: start;"></div>
              </div>
            </div>
          </div>

          <div class="d-flex w-100 justify-content-center mt-2 pb-1" style="background-color: var(--white)">
            <button class="btn btn-sm btn-outline-primary" (click)="openAddCommentModal(forum)">
              <i class="fa fa-comments"></i> comment
            </button>
          </div>
        </div>
      </div>
    </app-my-carousel-swiper>
  </div>

  <button
    *ngIf="isUserAnAdmin"
    class="mt-2 btn btn-sm btn-outline-primary mt-3"
    (click)="openForumAdd()"
  >
    Add Forum +
  </button>
</div>
